export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant04-de.931e2371.png";